import { render, staticRenderFns } from "./appAgentOrder.vue?vue&type=template&id=3132cdbd&scoped=true&"
import script from "./appAgentOrder.vue?vue&type=script&lang=js&"
export * from "./appAgentOrder.vue?vue&type=script&lang=js&"
import style0 from "./appAgentOrder.vue?vue&type=style&index=0&id=3132cdbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3132cdbd",
  null
  
)

export default component.exports